"use client"

import Image from "next/image";
import { useState, useEffect } from "react";
import { useRouter } from 'next/navigation'
import { usePathname } from 'next/navigation'
import tab_home_png from "@/app/assets/common/tabbar/tab_home.png";
import tab_message_png from "@/app/assets/common/tabbar/tab_message.png";
import tab_me_png from "@/app/assets/common/tabbar/tab_me.png";
import tab_home_active_png from "@/app/assets/common/tabbar/tab_home_active.png";
import tab_message_active_png from "@/app/assets/common/tabbar/tab_message_active.png";
import tab_me_active_png from "@/app/assets/common/tabbar/tab_me_active.png";

import { unreadCount } from "@/service/common/index";
import useMobileDetect from "@/hooks/useMobileDetect";
export default function Tabbar() {
  const router = useRouter()
  const tabbar_index = globalThis?.localStorage?.getItem("tabbar_index") || "0";
  const [tabbarIndex, setTabbarIndex] = useState(tabbar_index);
  const [count, setCount] = useState(0);
  const isMobile = useMobileDetect();
  const pathname = usePathname()

  useEffect(() => {
    if (!isMobile) return;
    unreadCount<{
      unreadCount: number
      defaultChatLink: string
    }>().then((res) => {
      if (res.code === 0) {
        const data = res.data
        setCount(data.unreadCount)
        globalThis?.localStorage?.setItem("defaultChatLink", data.defaultChatLink)
        // @ts-ignore
        globalThis?.getDefaultChatLinkCallback && globalThis.getDefaultChatLinkCallback(data.defaultChatLink)
      }
    });
  }, [tabbarIndex]);

  useEffect(() => {
    if (pathname === "/message") {
      setTabbarIndex("1")
    } else if (pathname === "/mine") {
      setTabbarIndex("2")
    } else {
      setTabbarIndex("0")
    }
  }, [pathname])

  const goToTab = (index: number) => {
    switch (index) {
      case 0:
        // window.location.href = '/';
        router.push('/')
        break;
      case 1:
        // window.location.href = '/message';
        router.push('/message')
        break;
      case 2:
        // window.location.href = '/mine';
        router.push('/mine')
        break;
      default:
        break;
    }
    setTabbarIndex(index + '')
    globalThis?.localStorage?.setItem("tabbar_index", index + '')
  }

  return isMobile ? (<>
    <div style={{
      height: '5.5rem', width: 'min(var(--max-width), 100%)', left: 0,
      bottom: 0, zIndex: 1, margin: '0 auto', justifyContent: 'center', right: 0
    }} className={isMobile ? "fixed flex" : "sticky hidden"}>
      <div style={{
        maxWidth: 'var(--max-width)', width: '100%', background: '#4A4573',
        borderRadius: '2rem 2rem 0 0', height: '100%', padding: '0 2rem',
        display: 'flex', justifyContent: 'space-evenly', alignItems: 'center',
      }}
      >
        <Image
          src={tabbarIndex === "0" ? tab_home_active_png : tab_home_png}
          width={28}
          height={28}
          alt={"tab_home_png"}
          style={{ width: '2.8rem', height: '2.8rem' }}
          onClick={() => { goToTab(0) }}
        />
        <div className="relative w-28 h-28">
          <Image
            src={tabbarIndex === "1" ? tab_message_active_png : tab_message_png}
            width={28}
            height={28}
            alt={"tab_message_png"}
            style={{ width: '2.8rem', height: '2.8rem' }}
            onClick={() => { goToTab(1) }}
          />
          {
            count > 0 && (
              <div className="absolute -top-10 -right-10 w-18 h-18 rounded-full bg-[#FF0000] text-white font-bold text-xs text-center">{count}</div>
            )
          }
        </div>
        <Image
          src={tabbarIndex === "2" ? tab_me_active_png : tab_me_png}
          width={28}
          height={28}
          alt={"tab_me_png"}
          style={{ width: '2.8rem', height: '2.8rem' }}
          onClick={() => { goToTab(2) }}
        />
      </div>
    </div>
    <div className="h-55"></div>
  </>
  ) : null
}
